import {goToByScroll} from "./go-to-by-scroll";
import {utils} from "./utils";

const breakpoint768 = window.matchMedia('(min-width: 768px)');

const shareToggle = document.querySelector('.share__toggle');

if (shareToggle !== null)
{
	shareToggle.addEventListener('click', function () {
		document.querySelector('.share__icons').classList.toggle('share__icons--open');
	});
}


document.querySelectorAll('.btn-prenota-open').forEach(function (el) {
	el.addEventListener('click', function (e) {
		document.querySelector('.viaggio-content-wrapper').style.display      = 'none';
		document.querySelector('.prenotazione-viaggio-wrapper').style.display = 'block';
		document.body.classList.add('ProductPrenotazioneShow');
		
		goToByScroll(document.querySelector('.prenotazione-viaggio-wrapper'), 0, 600);
	})
});


document.querySelectorAll('.btn-prenota-close').forEach(function (el) {
	el.addEventListener('click', function (e) {
		document.querySelector('.viaggio-content-wrapper').style.display      = 'block';
		document.querySelector('.prenotazione-viaggio-wrapper').style.display = 'none';
		document.body.classList.remove('ProductPrenotazioneShow');

		goToByScroll(document.querySelector('.viaggio-content-wrapper'), 0, 600);
	})
});



const productSearchForm = document.querySelector('.woocommerce-product-search');

if (productSearchForm !== null)
{
	const mainNavigation = document.querySelector('.main-navigation');
	const breakpoint768Checker = function () {

		if (breakpoint768.matches) // > 768px
		{
			mainNavigation.after(productSearchForm);
		}
		else // <= 768px
		{
			mainNavigation.append(productSearchForm);
		}
	}

	breakpoint768.addEventListener('change', breakpoint768Checker);
	breakpoint768Checker();
}


/**
 * Drag to scroll
 */
const viaggioPrezzi = document.querySelectorAll('.viaggio-prezzi');

viaggioPrezzi.forEach((el) => {
	new ScrollBooster({
		viewport:   el,
		scrollMode: 'transform',
		direction:  'horizontal',
		bounce:     false
	});
});


/**
 * Toggle accordion for FAQ blocks
 * @param e
 */
let toggleFaq = function (e) {
	e.preventDefault();

	let toggle = e.target;
	const transitionDuration = 600;

	if (toggle !== this && this.contains(toggle))
	{
		toggle = toggle.closest('.schema-faq-question');
	}

	// prevent from interrupting the animation
	if (toggle.classList.contains('animating'))
	{
		return;
	}
	else
	{
		toggle.classList.add('animating');
	}

	let content = toggle.nextElementSibling;

	if (content !== null)
	{
		toggle.classList.toggle('active');

		utils.slideToggle(content, transitionDuration);

		setTimeout(() => {
			toggle.classList.remove('animating');
		}, transitionDuration);
	}
};

document.querySelectorAll('.schema-faq-question').forEach(el => {

	el.addEventListener('click', toggleFaq);
	let content = el.nextElementSibling;
	content.style.display = 'none';

});



/**
 * ON LOAD
 */

window.addEventListener('load', function (event) {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});



/**
 * ON RESIZE
 */


window.addEventListener('resize', function (event) {

});



/**
 * ON RESIZE END
 */

// do something when the window resizing ends
window.addEventListener('resizeEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});

window.addEventListener('resizeHorizontallyEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});


/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/